﻿import {JSX} from "react";
import Button, {ButtonProps} from "../Buttons/Button";
import {useMvvmContext} from "./MvvmDataProvider";

export default function MvvmButton({waiting, children, ...rest}: ButtonProps): JSX.Element {
	const context = useMvvmContext<any>();
	return <Button waiting={context.isSubmitting() || context.isValidating() || waiting} {...rest}>{children}</Button>;
};
